// extracted by mini-css-extract-plugin
export default {"overlay":"global-loader-module__overlay--OEV","modal":"global-loader-module__modal--njU","body":"global-loader-module__body--fH7"};